import { SvgIcon } from '@mui/material'

// Types
import type { SvgIconProps } from '@mui/material'

const AddIconAtom = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<path opacity={0.4} fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M6 12H18" />
		<path fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M12 18V6" />
	</SvgIcon>
)

export default AddIconAtom
